var KEY={
LIFECYCLE:'redux-pack/LIFECYCLE',
TRANSACTION:'redux-pack/TRANSACTION'};


var LIFECYCLE={
START:'start',
SUCCESS:'success',
FAILURE:'failure'};


module.exports={
KEY:KEY,
LIFECYCLE:LIFECYCLE};